'use strict';

angular.module('mobile-apps').controller('UpgradeSubscriptionModalController', [
	'$scope',
	'Authentication',
	'SubscriptionMain',
	'Subscription',
	'Utilities',
	'SweetAlert',
	'ModalData',
	'$state',
	'$modalInstance',
	function (
		$scope,
		Authentication,
		SubscriptionMain,
		Subscription,
		Utilities,
		SweetAlert,
		ModalData,
		$state,
		$modalInstance
	) {
		$scope.processing = false;

		$scope.authentication = Authentication;
		$scope.exceededProperty = ModalData.exceededProperty;

		var userIncrementProperties = [];

		// If exceed values are given send them to server that a plan can be
		// found which matches the additional specifications
		if ($scope.exceededProperty) {
			userIncrementProperties.push($scope.exceededProperty);
		}

		// Get the information about the current and the needed plan from server
		Subscription.getUpgradeInfo({
			userIncrementProperties: userIncrementProperties
		}, function (data) {
			$scope.upgradeInfo = data.toJSON();
		}, function (err) {
			Utilities.showMessage(
				'Problem!',
				'There was a problem loading the subscriptions. Please contact the support! Thanks!',
				'error'
			);
			$scope.close();
		});

		/** 
		 *`Getting team members count excluding TPT user role
		*/
		$scope.getMembersCount = function(){
			if(!$scope.upgradeInfo || !$scope.upgradeInfo.userDataUsed || !$scope.upgradeInfo.userDataUsed.teamMembers){
				return 0;
			}
			
			if(typeof $scope.upgradeInfo.userDataUsed.teamMembers === 'number'){
				return $scope.upgradeInfo.userDataUsed.teamMembers;
			} else {
				var members = $scope.upgradeInfo.userDataUsed.teamMembers.filter(function(m){ return m.role && !m.role.toLowerCase().includes('tpt'); });

				if(members){
					return members.length;
				} else {
					return 0;
				}
			}
		};


		/**
		 * Close modal
		 */
		$scope.close = function() {
			$modalInstance.dismiss();
		};


		/**
		 * Upgrade the subscription
		 */
		$scope.startUpgrade = function () {

			// Make sure the user did already enter his billing
			// information
			if (!$scope.authentication.user._billing.billingDataEntered) {
				// If billing information not available redirect
				// him to the billings page

				$modalInstance.dismiss();

				Utilities.showMessage(
					'Problem!',
					'Your billing information is missing. It has to get entered first before account can be upgraded.',
					'error',
					function() {
						$state.go('listBillings');
					}
				);

				return;
			}

			SweetAlert.swal(
				{
					title             : 'Are you sure?',
					text              : 'This will upgrade you to a higher subscription which causes higher costs.',
					type              : 'info',
					showCancelButton  : true,
					confirmButtonColor: '#DD6B55',
					confirmButtonText : 'Yes, upgrade!',
					cancelButtonText  : 'No, cancel!',
					closeOnConfirm    : true,
					closeOnCancel     : true
				},
				function (isConfirm) {
					if (isConfirm) {

						$scope.processing = true;
						SubscriptionMain.upgradeSubscription($scope.upgradeInfo.neededSubscription.id, function(err, result) {
							$scope.processing = false;
							if (err) {
								Utilities.showMessage(
									'Problem!',
									'There was a problem updating your subscription:<br />' + err.data.message,
									'error'
								);
								return;
							}

							// Unlock user also in frontend in case he is
							// currently locked
							if (Authentication.user.accountLocked === true) {
								Authentication.user.accountLocked =false;
							}

							$modalInstance.close(result);
						});
					}
				}
			);
		};
	}
]);

